/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AuditEventType = {
    ConversationCreated: 'CONVERSATION_CREATED',
    ConversationIdUpdated: 'CONVERSATION_ID_UPDATED',
    ConversationArchived: 'CONVERSATION_ARCHIVED',
    ConversationLocked: 'CONVERSATION_LOCKED',
    ConversationUnlocked: 'CONVERSATION_UNLOCKED',
    ConversationSoftDeleted: 'CONVERSATION_SOFT_DELETED',
    ConversationHardDeleted: 'CONVERSATION_HARD_DELETED',
    ConversationDataUpdated: 'CONVERSATION_DATA_UPDATED',
    MessageSent: 'MESSAGE_SENT',
    ClientLoggedIn: 'CLIENT_LOGGED_IN',
    ParticipantAdded: 'PARTICIPANT_ADDED',
    ParticipantRemoved: 'PARTICIPANT_REMOVED',
    ParticipantNotified: 'PARTICIPANT_NOTIFIED',
    ParticipantNameChanged: 'PARTICIPANT_NAME_CHANGED',
    SmsSent: 'SMS_SENT',
    SmsWebhookReceived: 'SMS_WEBHOOK_RECEIVED',
    EmailSent: 'EMAIL_SENT',
    WorkflowExecuted: 'WORKFLOW_EXECUTED',
    WorkflowFailed: 'WORKFLOW_FAILED',
    TaskAttemptSuccess: 'TASK_ATTEMPT_SUCCESS',
    TaskAttemptFailed: 'TASK_ATTEMPT_FAILED',
    TaskRetryStopped: 'TASK_RETRY_STOPPED',
    UserAdded: 'USER_ADDED',
    UserRemoved: 'USER_REMOVED',
    UserPasswordChanged: 'USER_PASSWORD_CHANGED',
    UserLoggedIn: 'USER_LOGGED_IN',
    AssetUploaded: 'ASSET_UPLOADED',
    AssetDeleted: 'ASSET_DELETED',
    AssetUpdated: 'ASSET_UPDATED',
    WebhookSent: 'WEBHOOK_SENT',
    WebhookFailed: 'WEBHOOK_FAILED',
    GeocodingFallbackUsed: 'GEOCODING_FALLBACK_USED'
} as const;
export type AuditEventType = typeof AuditEventType[keyof typeof AuditEventType];


export function instanceOfAuditEventType(value: any): boolean {
    for (const key in AuditEventType) {
        if (Object.prototype.hasOwnProperty.call(AuditEventType, key)) {
            if (AuditEventType[key as keyof typeof AuditEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuditEventTypeFromJSON(json: any): AuditEventType {
    return AuditEventTypeFromJSONTyped(json, false);
}

export function AuditEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventType {
    return json as AuditEventType;
}

export function AuditEventTypeToJSON(value?: AuditEventType | null): any {
    return value as any;
}

export function AuditEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AuditEventType {
    return value as AuditEventType;
}

